import moment from 'moment';
import DeleteItemIcon from "../../../assets/delete-item.svg";
import EditItemIcon from "../../../assets/edit-item.svg";

export const ViewUserSpaces = ({
                                     data,
                                     editHandler,
                                     deleteHandler,
                                     isLoadingDelete
                                 }) => {
    return (
        <div className='table-responsive bg-light p-3 mt-2'>

            <table className='table table-sm table-border edit-grid-view'>
                <thead className='border-0'>
                <tr>
                    <th>Created</th>
                    <th>User</th>
                    <th>Spaces</th>
                    <th>Actions</th>
                </tr>
                </thead>

                <tbody>
                {data && data.data ? (
                    data.data.map((userSpace) => (
                        <tr key={userSpace._id}>
                            <td className="order-td">{moment(userSpace.createdAt).format('lll')}</td>
                            <td className="order-td">{userSpace.user.name}</td>
                            <td className="order-td">
                                {userSpace.spaces && userSpace.spaces.length > 0 ? (
                                    userSpace.spaces.map((space) => (
                                        <div key={space._id}>
                                            {space.name}
                                            {/*<img*/}
                                            {/*    src={userSpacesIcon}*/}
                                            {/*    alt="Space Icon"*/}
                                            {/*    style={{*/}
                                            {/*        width: '20px',*/}
                                            {/*        marginLeft: '8px'*/}
                                            {/*    }}*/}
                                            {/*/>*/}
                                        </div>
                                    ))
                                ) : (
                                    <div>No Spaces Assigned</div>
                                )}
                            </td>
                            <td>
                                <div className='btn-group'>
                                    <button
                                        className='btn'
                                        onClick={() => editHandler(userSpace)}
                                        data-bs-toggle='modal'
                                        data-bs-target='#userSpacesModal'
                                    >
                                        <img src={EditItemIcon} alt="Edit"
                                             className="icon-img action-icons-img"/>
                                    </button>

                                    <button
                                        className='btn'
                                        onClick={() => deleteHandler(userSpace._id)}
                                        disabled={isLoadingDelete}
                                    >
                                        {isLoadingDelete ? (
                                            <span className='spinner-border spinner-border-sm' />
                                        ) : (
                                            <img src={DeleteItemIcon} alt="Delete"
                                                 className="icon-img action-icons-img"/>
                                        )}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="8">Error: Failed to fetch User Spaces data</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
}

export default ViewUserSpaces;
